import { Field } from '@kanda-libs/ks-component-ts';
import Widgets from './Widgets';
import { useAddressFieldsContext } from './context';

const AddressFieldsContent: React.FunctionComponent = function () {
  const {
    buildingValidation,
    postcodeValidation,
    postcodeName,
    onPostcodeBlur,
    onBuildingBlur,
  } = useAddressFieldsContext();
  return (
    <div className="flex flex-col w-full text-left">
      <div className="flex flex-row gap-x-4">
        <Widgets.ManualField
          name="buildingName"
          validation={buildingValidation}
          onBlur={onBuildingBlur}
        />
        <Widgets.ManualField
          name="buildingNumber"
          validation={buildingValidation}
          onBlur={onBuildingBlur}
        />
      </div>
      <div className="flex flex-col md:flex-row gap-x-4">
        <Widgets.ManualField name="line1" />
        <Widgets.ManualField name="line2" />
      </div>
      <div className="flex flex-row gap-x-4">
        <Widgets.ManualField name="city" />
        <Field.Validator validation={postcodeValidation}>
          <Field.Input
            name={postcodeName}
            label="Postcode"
            placeholder="Postcode"
            onBlur={onPostcodeBlur}
          />
        </Field.Validator>
      </div>
      <div className="flex flex-row gap-x-4">
        <Widgets.ManualField name="county" />
        <Widgets.ManualField name="country" />
      </div>
    </div>
  );
};

export default AddressFieldsContent;
